@if (isLoading) {
  <loading class="pos-abs vh-center"></loading>
}
@if (!isLoading) {
  <div class="tw-bg-gray-100 tw-relative">
    @if (morningProducts.length || nightProducts.length) {
      <div id="calendarContainer" class="tw-sticky tw-top-12 tw-z-[5]">
        <!--    calendar -->
        <div class="tw-flex tw-justify-between tw-bg-gray-100 tw-h-16 tw-text-center tw-py-2 tw-px-6">
          @for (day of weekArray; track day) {
            <div class="" (click)="onDateSelect(day)">
              @if (+day?.date !== unChangedTodayDay) {
                <p class="tw-font-body tw-text-200 tw-capitalize"
                  [ngClass]="{'tw-opacity-50 tw-text-gray-800': !day.isSelected, 'tw-text-teal-600': day.isSelected}">
                  {{ day?.dayValue }}
                </p>
              }
              @if (+day?.date === unChangedTodayDay) {
                <p class="tw-font-body tw-text-200 tw-capitalize" data-testid="regimen-today" [ngClass]="{'tw-opacity-50 tw-text-gray-800': !day.isSelected, 'tw-text-teal-600': day.isSelected}">
                  Today
                </p>
              }
              <p class="tw-font-body tw-text-300 tw-uppercase tw-mt-1 tw-flex tw-justify-center tw-items-center">
                <span class="tw-w-6 tw-aspect-square tw-rounded-full tw-flex tw-justify-center tw-items-center"
                [ngClass]='{"tw-bg-teal-600  tw-text-white": day.isSelected, "tw-opacity-50 tw-text-gray-800": !day.isSelected}'>{{ day?.date }}</span>
              </p>
            </div>
          }
        </div>
      </div>
    }
    <div #morningAndNightTabs class="tw-transition-all tw-duration-500"
       [ngClass]='{
       "tw-top-[49px] " : !scrollingDown,
       "tw-top-[-20px]" : scrollingDown,
       }'
      >
      <!--    morning tabs-->
      @if (isDayTime) {
        <div class="tw-flex tw-flex-row tw-items-center tw-gap-[6px] tw-p-4 tw-sticky tw-top-12 tw-h-[59px] tw-bg-white">
          @if (morningProducts.length) {
            <div class="tw-flex-none tw-flex tw-flex-row tw-items-center tw-gap-1 tw-border tw-border-gray-400 tw-bg-yellow-100 tw-rounded-full tw-px-3 tw-py-2 tw-h-[30px] tw-w-[92px]" (click)="onMorningClick()">
              <cs-icon class="tw-h-4 tw-w-4 tw-text-yellow-400" [iconName]="'light_full'"></cs-icon>
              <p class="tw-font-body tw-text-200 tw-text-gray-900" i18n="@@morning"> Morning </p>
            </div>
          }
          @if (nightProducts.length) {
            <div class="tw-flex-none tw-flex tw-flex-row tw-items-center tw-gap-1 tw-border tw-border-gray-400 tw-rounded-full tw-px-3 tw-py-2 tw-h-[30px] tw-w-[75px]" (click)="onNightClick()">
              <cs-icon class="tw-h-4 tw-w-4 tw-text-gray-400" [iconName]="'clear_night'"></cs-icon>
              <p class="tw-font-body tw-text-200 tw-text-gray-400" i18n="@@night"> Night </p>
            </div>
          }
          <!-- Toggle Switch -->
          @if ((regimen.class === 'FACE') && (user?.get('orderState') === appConfig.Shared.User.OrderState.DELIVERED)) {
            <div class="tw-flex tw-flex-col tw-justify-center tw-items-center tw-ml-auto tw-p-0.5">
              <h3 class="tw-font-body tw-text-200" i18n="@@reminder">Reminder</h3>
              <div class="tw-relative tw-inline-block tw-w-10 tw-select-none">
                <input type="checkbox" name="toggle" id="reminderToggle"
                  class="tw-sr-only"
                  [checked]="reminderToggle"
                  (change)="setReminderToggleState($event)">
                <label for="reminderToggle"
                  class=" tw-mb-0 tw-block tw-overflow-hidden tw-h-6 tw-rounded-full tw-cursor-pointer tw-p-0.5 before:tw-content-[''] before:tw-absolute before:tw-h-5 before:tw-w-5 before:tw-rounded-full before:tw-left-0.5 before:tw-top-0.5 before:tw-transition-transform"
                 [ngClass]="{
                         'before:tw-translate-x-4 before:tw-bg-teal-600 tw-bg-teal-100': reminderToggle,
                         'before:tw-translate-x-0 before:tw-bg-white tw-bg-gray-400': !reminderToggle
                       }">
                </label>
              </div>
            </div>
          }
        </div>
      }
      <!--night tabs-->
      @if (!isDayTime) {
        <div class="tw-flex tw-flex-row tw-items-center tw-gap-[6px] tw-p-4 tw-sticky tw-top-12 tw-h-[59px] tw-bg-white">
          @if (morningProducts.length) {
            <div class="tw-flex-none tw-flex tw-flex-row tw-items-center tw-gap-1 tw-border tw-border-gray-400 tw-rounded-full tw-px-3 tw-py-2 tw-h-[30px] tw-w-[92px]" (click)="onMorningClick()">
              <cs-icon class="tw-h-4 tw-w-4 tw-text-gray-400" [iconName]="'light_mode'"></cs-icon>
              <p class="tw-font-body tw-text-200 tw-text-gray-400" i18n="@@morning"> Morning </p>
            </div>
          }
          @if (nightProducts.length) {
            <div class="tw-flex-none tw-flex tw-flex-row tw-items-center tw-gap-1 tw-border tw-border-black tw-rounded-full tw-px-3 tw-py-2 tw-h-[30px] tw-w-[75px] tw-bg-black" (click)="onNightClick()">
              <cs-icon class="tw-h-4 tw-w-4 tw-text-purple-200" [iconName]="'night_full'"></cs-icon>
              <p class="tw-font-body tw-text-200 tw-text-white" i18n="@@night"> Night </p>
            </div>
          }
        </div>
      }
    </div>
    @if (!morningProducts.length) {
      <div i18n="@@noMorningProductsTreatment" class="tw-flex tw-justify-center tw-items-center">
    <p class="tw-px-3 tw-py-5 tw-font-body tw-text-300 tw-text-gray-900 tw-text-center"> No morning products in your treatment kit. </p>
  </div>
    }
    @if (!nightProducts.length) {
      <div i18n="@@noNightProducts"  class="tw-flex tw-justify-center tw-items-center">
    <p class="tw-px-3 tw-py-5 tw-font-body tw-text-300 tw-text-gray-900 tw-text-center"> No night products in your treatment kit. </p>
  </div>
    }
    <!--  morning block -->
    @if (morningProducts?.length) {
      <section class="tw-flex tw-flex-col tw-gap-1 tw-p-4 tw-pb-0 tw-bg-gray-100">
        <div class="nightTab tw-absolute tw-top-[-120px]" id="morningBlock"></div>
        @for (item of morningProducts; track item; let i = $index) {
          <app-instruction-card
            [regimen]="regimen"
            [item]="item"
            [isDayTime]="true"
            [todayDayVal]="todayDayVal"
            [days]="days"
            [user]="user"
            [userLanguage]="userLanguage"
            [index]="i"
            [removedProducts]="removedProducts"
            [collapsableCardState] ="collapsableCard"
            [dayAfterDelivery]="dayAfterDelivery"
            [changeInstructionForRepairProduct]="changeInstructionForRepairProduct"
            (playButtonClick)="onPlayButtonClick($event)"
            (toggleProductCollapse)="toggleProductCollapse($event)"
            (knowMoreClicked)="toggleProductUpdatePopup($event)"
            >
          </app-instruction-card>
        }
      </section>
    }
    <!--  night block -->
    @if (nightProducts?.length) {
      <section class="tw-flex tw-flex-col tw-gap-1 tw-p-4 tw-bg-black tw-relative" #nightElementRelative="">
        <div class="nightTab tw-absolute tw-top-[-148px]" id="nightBlockScroll" #nightElement=""></div>
        @for (item of nightProducts; track item; let i = $index) {
          <app-instruction-card
            [item]="item"
            [regimen]="regimen"
            [isDayTime]="false"
            [todayDayVal]="todayDayVal"
            [days]="days"
            [user]="user"
            [userLanguage]="userLanguage"
            [removedProducts]="removedProducts"
            [collapsableCardState] ="collapsableCard"
            [index]="i"
            [dayAfterDelivery]="dayAfterDelivery"
            [changeInstructionForRepairProduct]="changeInstructionForRepairProduct"
            (toggleProductCollapse)="toggleProductCollapse($event)"
            (playButtonClick)="onPlayButtonClick($event)"
            (knowMoreClicked)="toggleProductUpdatePopup($event)"
            >
          </app-instruction-card>
        }
      </section>
    }
  </div>
}
<!--thumbs up/down-->
@if (thumbsUpDown) {
  <div class="card tw-flex tw-gap-2 tw-rounded-2xl tw-px-6 tw-pb-4 tw-mx-4 tw-mt-3 tw-bg-yellow-100 tw-relative tw-pt-7 tw-pr-8">
    <cs-icon class="tw-h-6 tw-w-6 tw-absolute tw-right-2 tw-top-2 tw-opacity-50" [iconName]='"close"' (click)="thumbsUpDown = false"></cs-icon>
    <p class="tw-font-body tw-flex-1 tw-text-400 tw-text-black" i18n="@@areTheseHelpful"> Are these instructions helpful? </p>
    <div class="tw-flex-none">
      <cs-button class="tw-border tw-rounded-full tw-border-black tw-text-green-400 tw-min-w-0" [class]="'btn-xs'" (callback)="thumpsUpDownRes(true)">
        <cs-button-text i18n="@@yes">Yes</cs-button-text>
      </cs-button>
    </div>
    <div class="tw-flex-none">
      <cs-button class="tw-border tw-rounded-full tw-border-black tw-text-green-400 tw-min-w-0" [class]="'btn-xs'" (callback)="thumpsUpDownRes(false)">
        <cs-button-text i18n="@@no">No</cs-button-text>
      </cs-button>
    </div>
  </div>
}
@if (showDietBannerV2) {
  <section class="tw-bg-yellow-100 tw-mt-2" (click)="myDietNew()">
    <div class="tw-px-4 tw-py-5 tw-flex tw-flex-col tw-gap-5">
      <!-- Header: Doctor avatar + title + chevron -->
      <div class="tw-flex tw-items-center tw-gap-2">
        <img src="/assets/images/diet-doctor.png"
          class="tw-w-12 tw-h-12 tw-rounded-full tw-object-cover tw-flex-shrink-0" alt="doctor" />
        <div class="tw-flex-1">
          <p class="tw-font-body tw-font-bold tw-text-400 tw-text-gray-800">Diet Instructions</p>
          <p class="tw-font-body tw-text-200 tw-text-[#535353] tw-italic">By Dr. Ramanjeet, Nutritionist</p>
        </div>
        <cs-icon class="tw-h-4 tw-w-4 tw-flex-shrink-0 tw-self-start tw-mt-1"
        [iconName]="'chevron_right_teal_rounded'"></cs-icon>
      </div>
      <!-- Avoid & Follow cards -->
      <div class="tw-flex tw-flex-col tw-gap-3">
        <!-- Avoid section -->
        <div class="tw-flex tw-flex-col tw-gap-3 tw-bg-gray-75 tw-rounded-2 tw-p-4 tw-overflow-hidden">
          <p class="tw-font-body tw-font-bold tw-text-400 tw-text-gray-800">Avoid</p>
          <div class="tw-flex tw-flex-col tw-gap-1.5">
            <!-- Acne: Milk, Sugar, Fried food -->
            @if (isAcneConcern) {
              <div class="tw-flex tw-items-center tw-h-10 tw-pl-3 tw-pr-2 tw-py-2 tw-border tw-border-gray-200 tw-rounded-2 tw-bg-gray-75 tw-overflow-hidden">
                <span class="tw-font-lexend tw-text-300 tw-text-gray-800"><span class="tw-leading-none">🥛</span> Milk &amp; Other Dairy Products <span class="tw-leading-none">❌</span></span>
              </div>
              <div class="tw-flex tw-items-center tw-h-10 tw-pl-3 tw-pr-2 tw-py-2 tw-border tw-border-gray-200 tw-rounded-2 tw-bg-gray-75 tw-overflow-hidden">
                <span class="tw-font-lexend tw-text-300 tw-text-gray-800"><span class="tw-text-[18px] tw-leading-none">🧁</span> Sugar <span class="tw-leading-none">❌</span></span>
              </div>
              <div class="tw-flex tw-items-center tw-h-10 tw-pl-3 tw-pr-2 tw-py-2 tw-border tw-border-gray-200 tw-rounded-2 tw-bg-gray-75 tw-overflow-hidden">
                <span class="tw-font-lexend tw-text-300 tw-text-gray-800"><span class="tw-leading-none">🍟</span> Fried &amp; Junk Food <span class="tw-leading-none">❌</span></span>
              </div>
            }
            <!-- Non-acne: Sugar, Fried food, Alcohol -->
            @if (!isAcneConcern) {
              <div class="tw-flex tw-items-center tw-h-10 tw-pl-3 tw-pr-2 tw-py-2 tw-border tw-border-gray-200 tw-rounded-2 tw-bg-gray-75 tw-overflow-hidden">
                <span class="tw-font-lexend tw-text-300 tw-text-gray-800"><span class="tw-leading-none">🧁</span> Sugar <span class="tw-leading-none">❌</span></span>
              </div>
              <div class="tw-flex tw-items-center tw-h-10 tw-pl-3 tw-pr-2 tw-py-2 tw-border tw-border-gray-200 tw-rounded-2 tw-bg-gray-75 tw-overflow-hidden">
                <span class="tw-font-lexend tw-text-300 tw-text-gray-800"><span class="tw-leading-none">🍟</span> Fried &amp; Junk Food <span class="tw-leading-none">❌</span></span>
              </div>
              <div class="tw-flex tw-items-center tw-h-10 tw-pl-3 tw-pr-2 tw-py-2 tw-border tw-border-gray-200 tw-rounded-2 tw-bg-gray-75 tw-overflow-hidden">
                <span class="tw-font-lexend tw-text-300 tw-text-gray-800"><span class="tw-leading-none">🥃</span> Alcohol &amp; Smoking <span class="tw-leading-none">❌</span></span>
              </div>
            }
          </div>
        </div>
        <!-- Follow section -->
        <div class="tw-flex tw-flex-col tw-gap-3 tw-bg-gray-75 tw-rounded-2 tw-p-4 tw-overflow-hidden">
          <p class="tw-font-body tw-font-bold tw-text-400 tw-text-gray-800">Follow</p>
          <div class="tw-flex tw-items-center tw-h-10 tw-pl-3 tw-pr-2 tw-py-2 tw-border tw-border-gray-200 tw-rounded-2 tw-bg-gray-75 tw-overflow-hidden">
            <span class="tw-font-lexend tw-text-300 tw-text-gray-800">Drink 8 glass (2 litres) of water daily <span class="tw-leading-none">✅</span></span>
          </div>
        </div>
      </div>
    </div>
  </section>
}
@if (showDietBannerRevamp) {
  <section class="tw-bg-yellow-100 tw-px-4 tw-py-6">
    <app-diet-guidance-banner class="tw-block" [class.tw-mb-10]="showReminderBanner" [regimen]="regimen" page="instruction"></app-diet-guidance-banner>
  </section>
}
<div class="video-container tw-fixed tw-top-0 tw-left-0 tw-right-0 tw-bottom-0 tw-hidden tw-z-[120]">
  <div class="tw-bg-black tw-absolute tw-inset-0"></div>
  <video class="tw-h-full tw-w-full tw-object-contain tw-max-w-full tw-max-h-full tw-relative tw-z-10" #videoPlayer controls="controls"></video>
  <button class="tw-absolute tw-top-2 tw-right-1 tw-rounded-full tw-h-8 tw-w-8 tw-flex tw-items-center tw-justify-end tw-text-white tw-font-bold tw-text-xl tw-z-10 close-video-button" (click)="closeVideo()">
    <svg class="tw-h-6 tw-w-6" fill="currentColor" viewBox="0 0 24 24">
      <path d="M18.3 5.71a.996.996 0 00-1.41 0L12 10.59 7.11 5.7A.996.996 0 105.7 7.11L10.59 12 5.7 16.89a.996.996 0 101.41 1.41L12 13.41l4.89 4.89a.996.996 0 101.41-1.41L13.41 12l4.89-4.89c.38-.38.38-1.02 0-1.4z"></path>
    </svg>
  </button>
</div>


<!-- product change update pop-up -->
@if (productUpdatePopupEnabled) {
  <div class="tw-fixed tw-inset-0 tw-z-10 tw-animate-fade_in backdrop-blur-sm" (click)="toggleProductUpdatePopup('AUTO')"></div>
  <div class="tw-fixed tw-bottom-0 tw-left-0 tw-right-0 tw-bg-white tw-z-20 tw-font-body tw-rounded-t-3xl tw-animate-slide_in_bottom tw-p-6">
    <div class="tw-pb-6 tw-flex-col -tw-mb-[8px]">
      <div class="tw-pb-4">
        <h2 class="tw-text-300 tw-font-bold tw-text-teal-600 tw-px-4 tw-py-1 tw-border tw-w-min tw-rounded-full custom-important-tag" i18n="@@important">Important</h2>
      </div>
      <div class="tw-pb-6">
        <h1 class="tw-text-700 tw-font-bold tw-w-[85%] tw-mb-2" i18n="@@productUpdateInYourTreatment">Product Update in Your Treatment</h1>
        <div class="tw-text-300 tw-relative -tw-top-1">
          <p i18n="@@followingYourRecentCheckUp">Following your recent check-up, I've</p>
          <br/>
          <ul class="tw-list-none tw-pl-2">
            @for (changes of regimenModifications; track changes) {
              <div class="tw-flex tw-gap-2 tw-items-start">
                <div class="tw-pt-2">
                  <span class="tw-w-1 tw-aspect-square tw-bg-black tw-rounded-full tw-block"></span>
                </div>
                <li>{{ changes }}</li>
              </div>
            }
          </ul>
        </div>
      </div>
      <div class="tw-flex tw-gap-2 tw-items-center tw-relative -tw-top-3">
        <img src="{{userDrImage}}" alt="{{latestReportDoctorName}}" class="tw-w-8 tw-aspect-square"/>
        <h3 class="tw-font-medium tw-font-body tw-text-300">{{latestReportDoctorName}}</h3>
        <img alt="tick" src="/assets/icons/orange_tick_new.svg" class="tw-h-4 tw-w-4" id="tick">
      </div>
    </div>
    @if (!dontShowCTA) {
      @if (!showGoToCart) {
        <div (click)="toggleProductUpdatePopup('AUTO')" class="tw-bg-teal-600 tw-text-white tw-text-300 tw-text-center tw-w-full tw-font-bold tw-capitalize tw-px-6 tw-py-[10px] tw-rounded-3" i18n="@@continue">Continue</div>
      }
      @if (showGoToCart) {
        <div (click)="goToCart()" class="tw-bg-teal-600 tw-text-white tw-text-300 tw-text-center tw-w-full tw-font-bold tw-capitalize tw-px-6 tw-py-[10px] tw-rounded-3" i18n="@@goToCart">Go to Cart</div>
      }
    }
    <div (click)="toggleProductUpdatePopup()" class="tw-absolute tw-right-[13px] tw-top-4 tw-w-9">
      <img alt="isNotifyMePopUp CloseButton" src="/assets/icons/popupCloseButton.svg"/>
    </div>
  </div>
}


<!-- instruction reminder turn off pop-up -->
@if (showInstructionReminderTurnOffPopup) {
  <div class="tw-fixed tw-inset-0 tw-z-10 tw-animate-fade_in backdrop-blur-sm" (click)="toggleInstructionReminderPopup(false)"></div>
  <div class="tw-fixed tw-top-1/2 tw-left-1/2 tw-transform tw--translate-x-1/2 tw--translate-y-1/2 tw-bg-white tw-rounded-3 tw-z-20 tw-font-body tw-w-[280px]">
    <!--    close button -->
    <div (click)="toggleInstructionReminderPopup(false)" class="tw-absolute tw-right-2 tw-top-2 tw-w-6">
      <img alt="isNotifyMePopUp CloseButton" src="/assets/icons/popupCloseButton.svg" class="tw-w-6 tw-aspect-square"/>
    </div>
    <div class="tw-w-[204px] tw-mx-auto tw-text-center tw-pt-5 tw-mb-6">
      <h1 class="tw-text-300 tw-font-[700] tw-mb-1" i18n="@@turnOffProductApplicationReminders">Are you sure you want to turn off the product application reminders?</h1>
      <p class="tw-text-200 tw-text-gray-500" i18n="@@mightMissOutOnReminders">You might miss out on reminders that help you stay on track.</p>
    </div>
    <div class="tw-flex tw-w-full tw-h-10 tw-border-t tw-border-t-gray-200 tw-text-300">
      <div (click)="toggleInstructionReminderPopup(false)" class="tw-flex-1 tw-flex tw-justify-center tw-items-center tw-border-r tw-border-r-gray-200">
        <h1 i18n="@@cancel">Cancel</h1>
      </div>
      <div (click)="turnOffInstructionReminder();" class="tw-flex-1 tw-flex tw-justify-center tw-items-center tw-text-teal-600 tw-font-[700]">
        <h1 i18n="@@turnOff">Turn off</h1>
      </div>
    </div>
  </div>
}

@if (isRouteMode) {
  <div class="tw-h-20"></div>
}

<!-- Route-mode footer buttons (match monolith's instruction footers) -->
@if (isRouteMode) {
  <div class="tw-fixed tw-bottom-0 tw-left-0 tw-right-0 tw-z-10">
    <!-- Reminder toggle container -->
    @if (!isLoading && regimen && showReminderContainer && (regimen.class === 'FACE') && (user?.get('orderState') === appConfig.Shared.User.OrderState.DELIVERED)) {
      <div>
        @if (!reminderEventSent && !isTabsVisible) {
          <div
            class="tw-flex tw-items-center tw-justify-between tw-w-full tw-min-h-12 tw-bg-teal-300 tw-p-2 tw-px-4">
            <h2 class="tw-font-body tw-flex-1 tw-text-200"
              i18n="@@getRemindersInstruction"><span class="tw-font-bold">Get reminders</span> for product application
        </h2>
            <div class="tw-flex tw-items-center tw-justify-end tw-gap-2">
              <div class="tw-relative tw-inline-block tw-w-10 tw-select-none tw-mb-[-7px]">
                <input type="checkbox"
                  name="toggle"
                  id="reminderToggleBanner"
                  class="tw-sr-only"
                  [checked]="reminderToggle"
                  (change)="onReminderBannerToggleChange($event)">
                <label for="reminderToggleBanner"
                  class="tw-block tw-overflow-hidden tw-h-6 tw-rounded-full tw-cursor-pointer tw-p-0.5 before:tw-content-[''] before:tw-absolute before:tw-h-5 before:tw-w-5 before:tw-rounded-full before:tw-left-0.5 before:tw-top-0.5 before:tw-transition-transform"
                   [ngClass]="{
                   'before:tw-translate-x-4 before:tw-bg-teal-600 tw-bg-white': reminderToggle,
                   'before:tw-translate-x-0 before:tw-bg-white tw-bg-gray-400': !reminderToggle
                 }">
                </label>
              </div>
              <div (click)="closeReminderBanner()"
                class="tw-relative -tw-right-[1px]">
                <img alt="close"
                  src="/assets/icons/reminderClose.svg"
                  class="tw-w-6 tw-h-6" />
              </div>
            </div>
          </div>
        }
        @if (reminderEventSent) {
          <div
            class="tw-flex tw-items-center tw-min-h-12 tw-bg-teal-300 tw-p-2 tw-px-">
            <img class="tw-h-6 tw-w-6"
              src="/assets/gifs/instruction-reminder.gif"
              alt="loader" />
            <h2 class="tw-font-body tw-flex-1 tw-text-200 tw-w-full"
            i18n="@@weWillRemindYou">We will remind you via app notifications</h2>
          </div>
        }
      </div>
    }

    <!-- Active + new UI: Read Detailed Instructions -->
    @if (regimen.active) {
      <div class="tw-bg-white tw-p-4"
        >
        <button class="tw-bg-teal-600 tw-w-full tw-py-2 tw-px-6 tw-text-white tw-text-center tw-rounded-3 tw-font-body tw-font-bold tw-h-[40px]"
          (click)="showPriceDetails()"
        i18n="@@readDetailedInstructions">Read Detailed Instructions</button>
      </div>
    }

    <!-- Unpaid + new UI: Full Details (teal) + Buy Now (teal) -->
    @if (!regimen.active && !regimen.orderPlaced && !isKeyboardVisible) {
      <div class="tw-bg-white tw-p-4 tw-flex tw-justify-around tw-gap-3"
        >
        <div class="tw-flex-1">
          <cs-button class="tw-border tw-rounded-full tw-border-teal-600 tw-text-teal-600"
            [class]="'w100 purple btn-xs'"
            [disabled]="isInternalUser"
            (callback)="readMoreAboutProducts()">
            <cs-button-text i18n="@@fullDetails">Full Details</cs-button-text>
          </cs-button>
        </div>
        <div class="tw-flex-1">
          <cs-button id="buyNowButton"
            class="tw-bg-teal-600 tw-rounded-full"
            [class]="'w100 primary btn-xs'"
            [disabled]="isInternalUser"
            (callback)="buyRegimen()">
            <cs-button-text i18n="@@buyNow">Buy Now</cs-button-text>
          </cs-button>
        </div>
      </div>
    }
  </div>
}
